import React, { useEffect, useState } from 'react';
import ControlDetail from './ControlDetail';
import { ImageElementType } from '../../redux/TabTile/TabStateInterfaces';
import './ToolsBar.css';

interface Props {
  selectedImageId: string | null;
  updateScaling: (id: string, scalingType: string) => void;
  imageElements: ImageElementType[];
  onUpdateImageElements: (updatedList: ImageElementType[]) => void;
  iconColor?: string;
  backgroundColor?: string;
  selectedTabBackgroundColor?: string;
}

const ObjectsOptions: React.FC<Props> = ({
  selectedImageId,
  imageElements,
  updateScaling,
  onUpdateImageElements,
  iconColor,
  backgroundColor,
  selectedTabBackgroundColor,
}) => {
  const selectedElement = imageElements.find((el) => el.id === selectedImageId);

  const dashboardOptions =
    selectedElement?.type === 'icon-button'
      ? ['Content', 'Properties', 'Action']
      : ['Size', 'Effects'];

  const [selectedOption, setSelectedOption] = useState(dashboardOptions[0]);

  useEffect(() => {
    setSelectedOption(dashboardOptions[0]);
  }, [selectedImageId, selectedElement?.type]);

  return (
    <>
      <div className="chartOptionImagesContainer">
        {dashboardOptions.map((option) => {
          const isSelected = selectedOption === option;
          const style = {
            color: iconColor,
            backgroundColor: isSelected ? selectedTabBackgroundColor : 'transparent',
            border: `2px solid ${isSelected ? selectedTabBackgroundColor : 'rgba(224, 224, 224, 1)'}`,
            fontWeight: isSelected ? 600 : 400,
          };

          return (
            <div
              key={option}
              onClick={() => setSelectedOption(option)}
              className={`optionImage ${isSelected ? 'optionImageSelected' : ''}`}
              style={style}
            >
              {option}
            </div>
          );
        })}
      </div>

      <ControlDetail
        selectedOption={selectedOption}
        selectedImageId={selectedImageId}
        imageElements={imageElements}
        updateScaling={updateScaling}
        onUpdateImageElements={onUpdateImageElements}
        iconColor={iconColor}
        backgroundColor={backgroundColor}
        selectedTabBackgroundColor={selectedTabBackgroundColor}
      />
    </>
  );
};

export default ObjectsOptions;
